import { lazy, Suspense, type ReactNode } from 'react';
import {
  Redirect,
  Route,
  Router,
  Switch,
} from 'wouter';
import { useAuth } from '@/core/auth/AuthProvider';
import { LoadingState } from '@/shared/ui/AsyncState';
import { LoginPage } from '@/pages/LoginPage';
import { AdminLayout } from '@/pages/AdminLayout';

const GuidesPage = lazy(() => import('@/pages/GuidesPage').then((module) => ({
  default: module.GuidesPage,
})));
const GuideEditorPage = lazy(() => import('@/pages/GuideEditorPage').then((module) => ({
  default: module.GuideEditorPage,
})));
const POIsPage = lazy(() => import('@/pages/POIsPage').then((module) => ({
  default: module.POIsPage,
})));
const LeadsPage = lazy(() => import('@/pages/LeadsPage').then((module) => ({
  default: module.LeadsPage,
})));

function RouteFallback() {
  return <div className="page"><LoadingState label="正在打开工作区…" /></div>;
}

function AuthLanding() {
  const { state } = useAuth();
  if (state === 'checking') return <div className="fullscreen-state"><LoadingState label="正在确认安全会话…" /></div>;
  if (state === 'authenticated') return <Redirect to="/app/guides" replace />;
  return <LoginPage />;
}

function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  if (state === 'checking') return <div className="fullscreen-state"><LoadingState label="正在确认安全会话…" /></div>;
  if (state === 'anonymous') return <Redirect to="/" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

export function AdminRouter() {
  return (
    <Router base="/admin">
      <Switch>
        <Route path="/"><AuthLanding /></Route>
        <Route path="/app"><Redirect to="/app/guides" replace /></Route>
        <Route path="/app/guides">
          <RequireAuth><Suspense fallback={<RouteFallback />}><GuidesPage /></Suspense></RequireAuth>
        </Route>
        <Route path="/app/guides/:guideID">
          <RequireAuth><Suspense fallback={<RouteFallback />}><GuideEditorPage /></Suspense></RequireAuth>
        </Route>
        <Route path="/app/pois">
          <RequireAuth><Suspense fallback={<RouteFallback />}><POIsPage /></Suspense></RequireAuth>
        </Route>
        <Route path="/app/leads">
          <RequireAuth><Suspense fallback={<RouteFallback />}><LeadsPage /></Suspense></RequireAuth>
        </Route>
        <Route><Redirect to="/" replace /></Route>
      </Switch>
    </Router>
  );
}
